<script>
import PaymentPlane from "../../../views/payment/payment-component.vue"
import appConfig from "@/app.config";
import Layout from "../../../layouts/main.vue"

export default {
    components:{Layout, PaymentPlane},
  page: {
    title: "Paiement Echoué",
    meta: [{ name: "description", content: appConfig.description }]
  },

  data() {
    return{
      message: "Votre paiement a échoué. Veuillez vérifier vos informations de paiement et réessayer.",

    }
  },
}

 
</script>



<template>
    <Layout>
        <PaymentPlane :message="message" :isSuccess="false"> </PaymentPlane>
    </Layout>
</template> 